'use client';
import { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';
import { Button, ButtonProps } from '@/shared/components/primitives/button';

type IconBtnProps = ButtonProps & {
  label: string;
  danger?: boolean;
  children: ReactNode;
};

export const IconButton = ({
  label,
  danger = false,
  className,
  children,
  ...props
}: IconBtnProps) => {
  return (
    <Button
      variant='noStyle'
      size='noStyle'
      aria-label={label}
      title={label}
      className={cn(
        'wtbtn relative inline-flex h-[40px] w-[46px] items-center justify-center',
        'rounded-none text-sm transition-colors select-none',
        danger
          ? 'hover:bg-red-600/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-400 active:bg-red-700/80'
          : 'hover:bg-[#75c636] focus-visible:outline focus-visible:outline-2 focus-visible:outline-neutral-300 active:bg-[#75c636]',
        className,
      )}
      {...props}
    >
      {children}
    </Button>
  );
};
